import { createAction, props } from '@ngrx/store';

import { LiveData } from '../../models/api';
import { LiveContentFilterType, LiveFilterType } from '../../models/common';
import { HomeSetting } from '../../services/local-storage.service';
import { Cas, PlatformType } from '../../models/home';

export const loadLives = createAction('[Home] Load Lives');

export const loadLivesSuccess = createAction(
  '[Home] Load Lives Success',
  props<{ livesRaw: LiveData[]; connectionCount: number; cas: Cas[] }>(),
);

export const loadLivesFailure = createAction(
  '[Home] Load Lives Failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>(),
);

export const addExternalLive = createAction(
  '[Home] Add External Live',
  props<{ videoId: string; platform: PlatformType }>(),
);

export const removeExternalLive = createAction(
  '[Home] Remove External Live',
  props<{ videoId: string }>(),
);

export const toggleChat = createAction(
  '[Home] Toggle Chat',
  props<{ videoId: string }>(),
);

export const toggleTopbar = createAction('[Home] Toggle Topbar');
export const toggleButtons = createAction('[Home] Toggle Buttons');
export const toggleFilter = createAction(
  '[Home] Toggle Filter',
  props<{ filterType: LiveFilterType }>(),
);

export const toggleContentFilter = createAction(
  '[Home] Toggle Content Filter',
  props<{ contentType: LiveContentFilterType }>(),
);

export const turnOff = createAction(
  '[Home] Turn Off Live',
  props<{ videoId: string }>(),
);

export const turnOn = createAction(
  '[Home] Turn On Live',
  props<{ videoId: string; platform: PlatformType }>(),
);

export const selectOne = createAction(
  '[Home] Select One',
  props<{ videoId: string; platform: PlatformType }>(),
);

export const loadSetting = createAction(
  '[Home] Load Setting',
  props<{ setting: HomeSetting }>(),
);
